import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';
import { Shield, AlertCircle, Mail } from 'lucide-react';

interface NoConsentNoServiceProps {
  onContactAdmin?: () => void;
}

export function NoConsentNoService({ onContactAdmin }: NoConsentNoServiceProps) {
  const { t } = useTranslation();

  const handleContactAdmin = () => {
    if (onContactAdmin) {
      onContactAdmin();
    } else {
      // Fallback: ouvrir le client email par défaut
      window.location.href = 'mailto:georges@d-block.fr?subject=Demande d\'accès Dashboard No Consent';
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Card className="max-w-2xl w-full mx-4">
        <CardContent className="p-12">
          <div className="text-center space-y-6">
            {/* Icône principale avec effet de gradient */}
            <div className="relative flex justify-center">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-24 h-24 bg-gradient-to-br from-green-100 to-emerald-100 dark:from-green-900/20 dark:to-emerald-900/20 rounded-full animate-pulse" />
              </div>
              <div className="relative z-10 p-6 bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/30 dark:to-emerald-900/30 rounded-full border border-green-200 dark:border-green-700">
                <Shield className="h-12 w-12 text-green-600 dark:text-green-400" />
              </div>
            </div>

            {/* Titre */}
            <div className="space-y-2">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                {t('noconsent.dashboard.noService.title')}
              </h2>
              
              {/* Message principal */}
              <p className="text-gray-600 dark:text-gray-400 text-lg leading-relaxed max-w-xl mx-auto">
                {t('noconsent.dashboard.noService.message')}
              </p>
            </div>

            {/* Zone d'informations supplémentaires */}
            <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 max-w-lg mx-auto">
              <div className="flex items-start space-x-3">
                <AlertCircle className="h-5 w-5 text-green-600 dark:text-green-400 mt-0.5 flex-shrink-0" />
                <div className="text-sm text-green-800 dark:text-green-200">
                  <p className="font-medium mb-1">
                    {t('common.needHelp')}
                  </p>
                  <p className="text-green-700 dark:text-green-300">
                    {t('noconsent.dashboard.noService.helpText')}
                  </p>
                </div>
              </div>
            </div>

            {/* Bouton d'action */}
            <div className="pt-4">
              <Button 
                onClick={handleContactAdmin}
                className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-3 rounded-lg font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <Mail className="h-4 w-4 mr-2" />
                {t('noconsent.dashboard.noService.contactAdmin')}
              </Button>
            </div>

            {/* Footer informatif */}
            <div className="pt-6 border-t border-gray-200 dark:border-gray-700">
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {t('noconsent.dashboard.noService.footer')}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}